import { c as _c } from "react/compiler-runtime";
import { useMarkets } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { CourtyardLogo } from "@opensea/ui-kit/icons";
import { ActivityFeedMarketplaceIconFragment } from "./ActivityFeedMarketplaceIcon.fragment";
const COLLECTION_SLUG_MARKETPLACE_LOGO = {
  /**
   * TODO: Courtyard marketplace should come from BE but they use Seaport
   * and there is no easy way to differentiate sales, so hardcoding on FE
   */
  "courtyard-nft": CourtyardLogo
};
export function ActivityFeedMarketplaceIcon(t0) {
  const $ = _c(4);
  const {
    activity: activityKey,
    fallback
  } = t0;
  const activity = readFragment(ActivityFeedMarketplaceIconFragment, activityKey);
  const {
    getLogo
  } = useMarkets();
  if (!activity) {
    return null;
  }
  let market;
  if (activity.__typename === "Sale") {
    market = activity.saleMarketplace.identifier;
  } else {
    if (activity.__typename === "Listing") {
      market = activity.listingMarketplace.identifier;
    } else {
      if (activity.__typename === "Mint") {
        market = activity.mintMarketplace?.identifier;
      }
    }
  }
  if (market) {
    const {
      icon: MarketplaceLogo
    } = getLogo(market);
    if (MarketplaceLogo) {
      let t1;
      if ($[0] !== MarketplaceLogo) {
        t1 = <MarketplaceLogo />;
        $[0] = MarketplaceLogo;
        $[1] = t1;
      } else {
        t1 = $[1];
      }
      return t1;
    }
  }
  const collectionSlug = activity.collection?.slug;
  if (collectionSlug) {
    const CollectionMarketplaceLogo = collectionSlug in COLLECTION_SLUG_MARKETPLACE_LOGO ? COLLECTION_SLUG_MARKETPLACE_LOGO[collectionSlug] : undefined;
    if (CollectionMarketplaceLogo) {
      let t1;
      if ($[2] !== CollectionMarketplaceLogo) {
        t1 = <CollectionMarketplaceLogo />;
        $[2] = CollectionMarketplaceLogo;
        $[3] = t1;
      } else {
        t1 = $[3];
      }
      return t1;
    }
  }
  return fallback;
}